import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import InvoicePaymentDataDisplay from '@/views/my-projects/components/invoice/paymentdata/InvoicePaymentDataDisplay.vue';
import { computed, ref, watch } from 'vue';
import InvoicePaymentDataEditor from '@/views/my-projects/components/invoice/paymentdata/InvoicePaymentDataEditor.vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { cloneDeep } from 'lodash';
import { PayloadUpdateInvoice } from '@/models/Invoice';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePaymentData',
  setup(__props) {

const {
  componentPaymentData, fetchUpdateInvoice, canInvoiceBeEdited, unsavedAreas, saveUnsavedChanges
} = useInvoice();
const { tUserFallback: t } = useUser('self');

const localPaymentData = ref(cloneDeep(componentPaymentData.value));
const isItEditing = computed({
  get: () => unsavedAreas.value.paymentData.isUnsaved,
  set: (val: boolean) => {
    unsavedAreas.value.paymentData.isUnsaved = val;
  }
});

// Payload should be updated with the local data
function createPayload(): PayloadUpdateInvoice {
  const paymentData = localPaymentData.value;
  const taxRate = parseFloat(
    paymentData.taxRate
      .toString()
      .replace(',', '.')
      .replace(/[^\w.]/g, '')
  );
  if (Number.isNaN(taxRate)) {
    throw new Error(
      `Invalid VAT value ${paymentData.taxRate
        .toString()
        .replace(',', '.')
        .replace(/[^\w.]/g, '')}`
    );
  }
  paymentData.taxRate = Math.round((taxRate + Number.EPSILON) * 100) / 100;
  return {
    accountData: {
      iban: paymentData.iban,
      bic: paymentData.bic,
      accountName: paymentData.accountName,
      currency: paymentData.currency,
      taxId: paymentData.taxId,
      taxRate: paymentData.taxRate,
      reverseCharge: paymentData.reverseCharge,
      reverseChargeTaxId: paymentData.reverseChargeTaxId
    }
  };
}

const saveCallback = async () => {
  try {
    const payload: PayloadUpdateInvoice = createPayload();
    await fetchUpdateInvoice(0, payload).then(() => {
      componentPaymentData.value = localPaymentData.value;
      isItEditing.value = false;
    });
  } finally {
    unsavedAreas.value.paymentData.isProcessing = false;
  }
};

/**
 * Resets the local payment data to the current global payment data, discarding any unsaved changes when canceling.
 */
function onCancel() {
  localPaymentData.value = cloneDeep(componentPaymentData.value);
}

// If reactive data changes, it is updated
watch(
  () => componentPaymentData.value,
  () => {
    if (!isItEditing.value) {
      localPaymentData.value = cloneDeep(componentPaymentData.value);
    }
  }
);

watch(
  () => saveUnsavedChanges.value,
  (newVal) => {
    if (newVal === 'save' && unsavedAreas.value.paymentData.isUnsaved) {
      unsavedAreas.value.paymentData.isProcessing = true;
      saveCallback();
    } else unsavedAreas.value.paymentData.isProcessing = false;
  }
);

return { __sfc: true,componentPaymentData, fetchUpdateInvoice, canInvoiceBeEdited, unsavedAreas, saveUnsavedChanges, t, localPaymentData, isItEditing, createPayload, saveCallback, onCancel, InvoiceSection, InvoicePaymentDataDisplay, InvoicePaymentDataEditor }
}

})